<template>
  <main class="legal">
    <h1>{{ isPrivacy ? 'Политика конфиденциальности' : 'Пользовательское соглашение' }}</h1>
    <template v-if="isPrivacy">
      <p><strong>Дата редакции: 30 июля 2026 года.</strong></p>
      <p>Настоящая Политика описывает обработку данных пользователей ювелирного калькулятора (далее — «Сервис»).</p>
      <h2>1. Оператор</h2>
      <p><strong>Климов А.А.</strong>, ИНН <strong>505501495283</strong>, email: <strong>serebriaka@yandex.ru</strong> (далее — «Оператор»).</p>
      <h2>2. Какие данные обрабатываются</h2>
      <p>Могут обрабатываться IP-адрес, cookie, сведения об устройстве и браузере, источник перехода, посещённые разделы и действия в интерфейсе. Внутри Telegram Сервис также может получать идентификатор и открытые данные профиля, переданные платформой.</p>
      <h2>3. Цели и основания</h2>
      <p>Данные используются для работы Сервиса, сохранения прогресса и достижений, безопасности, анализа востребованности функций и улучшения интерфейса. Аналитика включается только после нажатия «Разрешить».</p>
      <h2>4. Яндекс Метрика</h2>
      <p>Сервис использует Яндекс Метрику, предоставляемую ООО «ЯНДЕКС». Метрика получает технические данные и сведения о взаимодействии с интерфейсом с использованием cookie. Мы не передаём в цели Метрики Telegram ID, имя, телефон, email или введённые в калькуляторы значения.</p>
      <h2>5. Хранение и передача</h2>
      <p>Данные обрабатываются не дольше, чем это необходимо для указанных целей или требуется законом. Доступ может предоставляться поставщикам инфраструктуры и аналитики в необходимом объёме.</p>
      <h2>6. Права пользователя</h2>
      <p>Пользователь может запросить сведения об обработке, уточнение, блокирование или удаление данных, отозвать согласие, а также обратиться в Роскомнадзор или суд. Запрос направляется на email Оператора.</p>
      <h2>7. Управление аналитикой</h2>
      <p>Отказаться можно при первом запуске. Чтобы изменить выбор позже, очистите данные сайта в браузере или обратитесь к Оператору.</p>
    </template>
    <template v-else>
      <p><strong>Дата редакции: 30 июля 2026 года.</strong></p>
      <p>Используя Сервис, пользователь принимает условия настоящего Соглашения. Если условия не подходят, использование следует прекратить.</p>
      <h2>1. Назначение</h2>
      <p>Сервис предоставляет справочные ювелирные калькуляторы. Результаты являются расчётными, могут содержать погрешности и не заменяют профессиональную проверку технологии, состава или стоимости изделия.</p>
      <h2>2. Правила использования</h2>
      <p>Пользователь обязуется не нарушать работу Сервиса, не пытаться получить несанкционированный доступ и самостоятельно проверять исходные данные и результаты.</p>
      <h2>3. Ответственность</h2>
      <p>Сервис предоставляется «как есть». В допустимых законом пределах Оператор не отвечает за решения, принятые исключительно на основании расчётов, упущенную выгоду и косвенные убытки.</p>
      <h2>4. Интеллектуальные права</h2>
      <p>Права  на интерфейс, тексты, изображения и программный код принадлежат их правообладателям.</p>
      <h2>5. Персональные данные</h2>
      <p>Порядок обработки данных и использования Метрики описан в <router-link to="/privacy">Политике конфиденциальности</router-link>.</p>
      <h2>6. Изменение условий</h2>
      <p>Оператор может обновлять Соглашение. Новая редакция действует с момента публикации.</p>
      <h2>7. Контакты</h2>
      <p>Оператор: <strong>Климов А.А.</strong>, email: <strong>serebriaka@yandex.ru</strong>.</p>
    </template>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const isPrivacy = computed(() => route.name === 'privacy')
</script>

<style scoped>
.legal { width: min(760px, 100%); box-sizing: border-box; padding: 20px 8px 100px; overflow-y: auto; color: #fff; line-height: 1.55; }
.legal h1 { font-size: 24px; }
.legal h2 { margin-top: 22px; font-size: 17px; }
.legal p { font-size: 14px; }
.legal a { color: #b9ffff; }
</style>
